/* Nomadist Lab — sélecteur de lots sur la fiche produit.
   Il pilote le champ quantité natif du thème (masqué) et affiche le total dans le bouton d'achat. */
(function(){
  function euros(cents){
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function init(root){
    if (root.dataset.nlabReady) return;
    root.dataset.nlabReady = '1';
    var info = root.closest('.product__info-wrapper') || document;
    var qtyInput = info.querySelector('input.quantity__input[name="quantity"]');
    var submit = info.querySelector('.product-form__submit');
    var label = submit ? submit.querySelector('span') : null;
    var baseLabel = label ? label.textContent.trim() : '';
    var tiers = root.querySelectorAll('.nlab-tier');

    function select(tier){
      Array.prototype.forEach.call(tiers, function(t){
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (label && submit && !submit.disabled) {
        label.textContent = baseLabel + ' | ' + euros(parseInt(tier.getAttribute('data-total'), 10));
      }
    }

    Array.prototype.forEach.call(tiers, function(t){
      t.addEventListener('click', function(){ select(t); });
    });
    var current = root.querySelector('.nlab-tier.is-selected') || tiers[0];
    if (current) select(current);
  }

  function run(){ document.querySelectorAll('[data-nlab-tiers]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
